
import { Component, Vue, Prop } from "vue-property-decorator";
import banner_img from "@/assets/images/projects_banner.png";
import { projectInfo } from "@/apis/home";
import { setCount } from "@/apis/home";
import md5 from "blueimp-md5";
@Component({
  components: {}
})
export default class Project extends Vue {
  banner_img = banner_img;
  //   mba=光华MBA;emba=共创会EMBA
  ukey: any = "emba";
  info: any = {};
  created() {
    if (this.$route.query.ukey) {
      this.ukey = this.$route.query.ukey;
    }
    this.projectInfo();
  }
  //   切换
  handleBtn(val: any) {
    this.ukey = val;
    this.projectInfo();
  }
  async handleChat() {
    let params = {
      type: 1,
      type_id: this.info.project_id,
      md5: md5(1 + "&" + this.info.project_id + "&Z6pdIPQ4aFDwgxOZ")
    };
    await setCount(params);
    openJesongChat("32182", "102497");
  }

  async projectInfo() {
    this.info = await projectInfo({
      ukey: this.ukey
    });
  }
  // 课程预告
  handleCourse() {
    let index = 2;
    if (this.ukey == "emba") {
      index = 2;
    } else if (this.ukey == "emba") {
      index = 1;
    } else {
      index = 3;
    }
    this.$router.push(`/course?type=${index}`);
  }
}
